import { camelCase } from 'lodash';

import { ActiveVehicle } from './active-vehicle.model';

export class AccountInfo {
  customerName: string = null;
  customerDisplayName: string = null;
  address: string = null;
  postCode: string = null;
  suburb: string = null;
  state: string = null;
  contact: string = null;
  phoneNumber: string = null;
  mobileNumber: string = null;
  email: string = null;
  timezone: number = null;
  fbt: string = null;
  reports: string = null;
  activeVehicles: ActiveVehicle[] = [];

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== 'undefined') {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
